import { createConfirmation } from "react-confirm";
import AddNewCategoryDialogRecipe from "./AddNewCategoryDialogRecipe";

export const showAddNewCategoryDialogRecipe = createConfirmation(AddNewCategoryDialogRecipe);
